import { get, post } from './http-calls';

export const getVehicleDetailsByReg = async (searchText) => {
    let res = await get(`HeaderRecords/GetVehicleDetailsByReg?searchText=${searchText}`, { useAuthToken: true });
    return res;
};

export const getJobBookingDropdowns = async () => {
    let res = await get(`WorkflowJobs/JobBooking_Dropdowns`, { useAuthToken: true });
    return res;
};

export const createHeaderRecord = async (data) => {
    let res = await post(`HeaderRecords`, data, { useAuthToken: true });
    return res;
};

export const addVehicle = async (data) => {
    let res = await post(`Vehicles`, data, { useAuthToken: true });
    return res;
};

export const getVehicleScreenDropdowns = async () => {
    let res = await get(`Vehicles/VehicleScreen_Dropdowns`, { useAuthToken: true });
    return res;
};
